import { Resources } from 'constants/resources';

import { required } from 'react-admin';
import { useForm, FormProvider } from 'react-hook-form';
import { Alert } from 'shared/mui/Alert/Alert';
import { Box } from 'shared/mui/Box';
import { Button } from 'shared/mui/Buttons';
import { AutocompleteInput } from 'shared/react-admin/Inputs/AutocompleteInput/AutocompleteInput';
import { TextInput } from 'shared/react-admin/Inputs/TextInputs/TextInput/TextInput';
import { ListPage } from 'shared/react-admin/Pages';

import { useOrdersBulkUpdate } from './hooks/useOrdersBulkUpdate';
import { useRoleOrderStatusChoices } from './hooks/useRoleOrderStatusChoices';

export type OrdersBulkUpdateValues = {
  orderIds: string;
  orderStatus: string;
};

export const OrdersBulkUpdateForm: React.FC = () => {
  const roleOrderStatusChoices = useRoleOrderStatusChoices();

  const form = useForm<OrdersBulkUpdateValues>({
    defaultValues: { orderIds: '', orderStatus: '' },
  });

  const { result, handleSubmit, clear } = useOrdersBulkUpdate(form);

  const alerts = [
    { severity: 'success', label: 'Успешно выполнено для заказов', ids: result.foundIds },
    { severity: 'error', label: 'Заказы не найдены', ids: result.notFoundIds },
    {
      severity: 'error',
      label: 'Изменение статуса невозможно для следующих заказов',
      ids: result.notAllowedIds,
    },
  ] as const;

  return (
    <ListPage
      empty={false}
      headerTitle={{ titleText: 'Массовое изменение статусов заказов' }}
      pagination={<></>}
      queryOptions={{ enabled: false }}
      resource={Resources.OrdersBulkUpdate}
    >
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(handleSubmit)}>
          <Box alignItems="flex-start" display="flex" gap={3}>
            <TextInput
              label="Id заказов через запятую"
              resettable
              source="orderIds"
              sx={{ flex: 1 }}
              validate={required()}
              variant="outlined"
            />
            <AutocompleteInput
              choices={roleOrderStatusChoices}
              label="Статус"
              source="orderStatus"
              sx={{ flex: 1 }}
              validate={required()}
              variant="outlined"
            />
            <Button label="Очистить" onClick={clear} sx={{ height: 40 }} variant="outlined" />
            <Button label="Применить" sx={{ height: 40 }} type="submit" variant="contained" />
          </Box>
          <Box display="flex" flexDirection="column" gap={2}>
            {alerts
              .filter(({ ids }) => ids.length > 0)
              .map(({ severity, label, ids }) => (
                <Alert key={label} severity={severity}>
                  {label}:{' '}
                  <Box component="span" fontWeight={500}>
                    {ids.join(', ')}
                  </Box>
                </Alert>
              ))}
          </Box>
        </form>
      </FormProvider>
    </ListPage>
  );
};
